import React from "react";
import "./Destaque.css";

function Destaque() {
    return (
        <div className="destaque-container">
            <h2>Na <strong>Adornik</strong>, transformamos <strong>aço</strong> em expressão, elegância em essência.</h2>
            <br /> 
            <br />
            <h2>Cada peça que criamos é uma obra de <strong>arte em aço</strong>, feita com precisão, propósito e paixão.</h2>
            
        </div>
    )
}

export default Destaque;